/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import {
  connect,
} from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  injectIntl,
} from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Table,
  Collapse,
  Well,
} from 'react-bootstrap';
import {
  getGatewayStatus,
  getGatewayNodeStatus,
} from 'loraapi/lora_network';
import {
  normalizeDevEUI,
} from 'lorautils/IdUtils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Toolbar from 'loracoms/Toolbar';
import GatewayPie from './coms/GatewayPie';
import SortFlag from './coms/SortFlag';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

class GatewayView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gateways: [],
      nodes: [],
      selectGatewayId: '',
      gatewaySort: { sortName: '', sortOrder: '' },
      nodeSort: { sortName: '', sortOrder: '' },
      distribution: {},
      showHelp: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.analytics.gateway');
    this.flowRange = this.flowRange.bind(this);
  }

  componentDidMount() {
    this.loadGateway('flow', 'desc', true, { gatewaySort: { sortName: 'flow', sortOrder: 'desc' } });
  }

  flowRange(flow) {
    const base = 1024 * 1024;
    if (flow < base) {
      return 1;
    } else if (flow >= base && flow < 10 * base) {
      return 2;
    }
    return 3;
  }

  toaRange(toa) {
    if (toa < 60 * 1000) {
      return 1;
    } else if (toa >= 60 * 1000 && toa < 60 * 60 * 1000) {
      return 2;
    }
    return 3;
  }

  invalidRange(invalidPre) {
    if (invalidPre < 10) {
      return 1;
    } else if (invalidPre >= 10 && invalidPre < 30) {
      return 2;
    } else if (invalidPre >= 30 && invalidPre < 60) {
      return 3;
    } else if (invalidPre >= 60 && invalidPre < 90) {
      return 4;
    }
    return 5;
  }

  parserDistribution(gateways = []) {
    let toaDistri = { 1: 0, 2: 0, 3: 0 };
    let flowDistri = { 1: 0, 2: 0, 3: 0 };
    let invalidDistri = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    gateways.forEach((gateway) => {
      const flowKey = this.flowRange(gateway.flow);
      flowDistri[flowKey] = flowDistri[flowKey] + 1;

      const toaKey = this.toaRange(gateway.toa);
      toaDistri[toaKey] = toaDistri[toaKey] + 1;

      const invalidKey = this.invalidRange(gateway.invalid_pre);
      invalidDistri[invalidKey] = invalidDistri[invalidKey] + 1;
    });
    return { toa: toaDistri, flow: flowDistri, invalid: invalidDistri };
  }

  loadGateway(sortName, sortOrder, cascade = true, state = {}) {
    getGatewayStatus(sortName, sortOrder).then((res) => {
      const list = res.body.list;
      if (list.length > 0) {
        const distri = this.parserDistribution(list);
        if (cascade) {
          this.loadGatewayNode(list[0].gateway, 'flow', 'desc', {
            distribution: distri,
            gateways: res.body.list,
            selectGatewayId: list[0].gateway,
            nodeSort: { sortName: 'flow', sortOrder: 'desc' },
            ...state,
          });
        } else {
          this.setState({ distribution: distri, gateways: res.body.list, ...state });
        }
      }
    });
  }

  loadGatewayNode(gateway, sortName, sortOrder, state = {}) {
    return getGatewayNodeStatus(gateway, sortName, sortOrder).then((res) => {
      this.setState({ nodes: res.body.list, selectGatewayId: gateway, ...state });
    });
  }

  fixedNumber(value) {
    return Number(value).toFixed(2);
  }

  handleGatewayChange(gatewayId) {
    this.loadGatewayNode(gatewayId, 'flow', 'desc', { nodeSort: { sortName: 'flow', sortOrder: 'desc' } });
  }

  handleGatewaySortChange(sortInfo) {
    this.loadGateway(sortInfo.sortName, sortInfo.sortOrder, false, { gatewaySort: sortInfo });
  }

  handleNodeSortChange(sortInfo) {
    this.loadGatewayNode(this.state.selectGatewayId, sortInfo.sortName,
      sortInfo.sortOrder, { nodeSort: sortInfo });
  }

  renderGateway() {
    const { gateways, gatewaySort, selectGatewayId } = this.state;
    return (<Panel bsStyle="aisz-white" header={this.intlMsg.msg('rank.gateway')}>
      <Table className="aisz-table-light" bordered responsive>
        <thead>
          <tr>
            <th>
              {this.intlMsg.msg('rank')}
            </th>
            <th> {this.intlMsg.msg('gateway')} </th>
            <th>
              {`${this.intlMsg.msg('flow')}(Byte)`}
              <SortFlag
                keyName="flow"
                handleSortChange={data => this.handleGatewaySortChange(data)}{...gatewaySort}
              />
            </th>
            <th>
              {`${this.intlMsg.msg('toa')}(ms)`}
              <SortFlag keyName="toa" handleSortChange={data => this.handleGatewaySortChange(data)}{...gatewaySort} />
            </th>
            <th>
              {`${this.intlMsg.msg('invalid_pre')}(%)`}
              <SortFlag
                keyName="invalid_pre"
                handleSortChange={data => this.handleGatewaySortChange(data)}{...gatewaySort}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {
          gateways.map((item, index) => (
            <tr
              key={index} onClick={() => this.handleGatewayChange(item.gateway)}
              className={`${item.gateway === selectGatewayId ? styles.select : ''}`}
            >
              <td>
                {index + 1}
              </td>
              <td>
                <a onClick={() => this.props.pushState(`/gateway/detail/${item.gateway}`)}>
                  {normalizeDevEUI(item.gateway)}
                </a>
              </td>
              <td>{item.flow}</td>
              <td>{item.toa}</td>
              <td>{this.fixedNumber(item.invalid_pre)}</td>
            </tr>
          ))
        }
        </tbody>
      </Table>
    </Panel>);
  }

  renderNodes() {
    const { nodes = [], nodeSort, selectGatewayId } = this.state;
    const header = (<div>{this.intlMsg.msg('rank.node')}(
      <span className={styles.selectId}>{normalizeDevEUI(selectGatewayId)}
      </span>)
    </div>);
    return (<Panel bsStyle="aisz-white" header={header}>
      <Table className="aisz-table-light" striped bordered responsive>
        <thead>
          <tr>
            <th>
              {this.intlMsg.msg('rank')}
            </th>
            <th> {this.intlMsg.msg('node')} </th>
            <th>
              {`${this.intlMsg.msg('flow')}(Byte)`}
              <SortFlag
                keyName="flow"
                handleSortChange={data => this.handleNodeSortChange(data)}{...nodeSort}
              />
            </th>
            <th>
              {`${this.intlMsg.msg('toa')}(ms)`}
              <SortFlag
                keyName="toa"
                handleSortChange={data => this.handleNodeSortChange(data)}{...nodeSort}
              />
            </th>
            <th>
              {`${this.intlMsg.msg('invalid_pre')}(%)`}
              <SortFlag
                keyName="invalid_pre"
                handleSortChange={data => this.handleNodeSortChange(data)}{...nodeSort}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {
          nodes.map((item, index) => (
            <tr key={index}>
              <td>
                {index + 1}
              </td>
              <td>
                <a onClick={() => this.props.pushState(`/application/${item.appeui}/devices/${item.deveui}`)}>
                  {normalizeDevEUI(item.deveui)}
                </a>
              </td>
              <td>{item.flow}</td>
              <td>{item.toa}</td>
              <td>{this.fixedNumber(item.invalid_pre)}</td>
            </tr>
          ))
        }
        </tbody>
      </Table>
    </Panel>);
  }

  renderGlobal() {
    const { distribution } = this.state;
    return (<Panel bsStyle="aisz-white">
      <Row>
        <Col md={4}>
          <GatewayPie keyName="flow" title={'网关分布(按流量)'} seriesData={distribution.flow || {}} />
        </Col>
        <Col md={4}>
          <GatewayPie keyName="invalid_pre" title={'网关分布(按冗余度)'} seriesData={distribution.invalid || {}} />
        </Col>
        <Col md={4}>
          <GatewayPie keyName="toa" title={'网关分布(按TOA)'} seriesData={distribution.toa || {}} />
        </Col>
      </Row>
    </Panel>);
  }

  renderToolbar() {
    const title = (<div>{this.intlMsg.msg('title')}
      <span
        onClick={() => {
          this.setState({ showHelp: !this.state.showHelp });
        }} className={`glyphicons glyphicons-question-sign ${styles.help}`}
      />
    </div>);
    return (<Toolbar
      brandTitle={title}
    />
    );
  }

  renderHelpWell() {
    return (
      <Well bsClass="aisz-well-light">
        <div>
          <p>
            {this.intlMsg.msg('total.help')}
          </p>
          <p>
            {this.intlMsg.msg('flow.help')}
          </p>
          <p>
            {this.intlMsg.msg('toa.help')}
          </p>
          <p>
            {this.intlMsg.msg('invalid_pre.help')}
          </p>
        </div>
      </Well>
    );
  }

  render() {
    const { gateways,distribution } = this.state;
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Collapse in={this.state.showHelp}>
          <Row>
            <Col md={12}>
              { this.renderHelpWell() }
            </Col>
          </Row>
        </Collapse>
        <Row>
          <Col md={12}>
            {gateways.length>0&&this.renderGlobal()}
          </Col>
          <Col md={6}>
            {this.renderGateway()}
          </Col>
          <Col md={6}>
            {this.renderNodes()}
          </Col>
        </Row>
      </Grid>
    );
  }
}


GatewayView.propTypes = propTypes;

export default connect(
  () => ({}),
  { pushState: routerActions.push },
)(injectIntl(GatewayView));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/GatewayView/index.jsx